























































import { Component, Vue, Prop } from "vue-property-decorator";
import { BLink } from "bootstrap-vue";

@Component({
  components: {
    BLink,
  },
})
export default class ContentsPage extends Vue {
  @Prop() protected readonly contentsList!: {
    ContentsTitle: string;
    ContentsPath: string;
    ContentsImage: string;
  }[];
}
